import * as React from 'react';
import * as _ from 'lodash';

import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';

export const ClientPhoneNumbers = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        // handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    }); 

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        // onChange: (n, v) => { handleFormInputChange(n, v); },
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
    });

    return (
        <DetailFormCommon.ClientDetailFormSection title={sectionTitle}>
            <div>               
                <KendoWrappers.KendoTextInputDebounced
                    name="phone"
                    label={appText('phone')}
                    value={formData.phone}
                    {...inputPropsFullWidthTextDebounced}
                />

                <KendoWrappers.KendoTextInputDebounced
                    name="fax"
                    label={appText('fax')}
                    value={formData.fax}
                    {...inputPropsFullWidthTextDebounced}
                />
            </div>
        </DetailFormCommon.ClientDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/client/detail-form/client-phone-numbers.tsx